import styled from 'styled-components';
import { CarouselNavControlsMixin } from '../../mixins/components/CarouselNavControlsMixin';
export var StyledCarouselNavControls = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledCarouselNavControls",
  componentId: "c11n-8-107-0__sc-1moj1il-0"
})(["", ""], CarouselNavControlsMixin);